<!-- <app-loader *ngIf="isLoading()" /> -->
<div class="dialog-header">
    <h6>{{ isEditMode ? 'Edit ' + existingdata.serviceName : 'Add ' + existingdata.serviceName }}</h6>
    <div class="header-buttons">

        <button class="add-row-btn" mat-flat-button (click)="addRow()" *ngIf="!isEditMode">+ Add Row</button>

        <button mat-flat-button color="primary" class="add-tariff-service" type="submit" form="serviceForm">
            {{ isEditMode ? 'Update ' + existingdata.serviceName : 'Save ' + existingdata.serviceName }}
        </button>
        <button mat-icon-button class="close-icon" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
</div>

<form [formGroup]="serviceForm" (ngSubmit)="onSubmit()" id="serviceForm">
    <div class="form-container">
        <ng-container formArrayName="rows">
            <div *ngFor="let rowGroup of rowsArray.controls; let rowIndex = index" [formGroupName]="rowIndex"
                class="row-container">
                <div class="row-header" *ngIf="!isEditMode">
                    <span>Row {{ rowIndex + 1 }}</span>
                    <button mat-icon-button class="delete-btn" type="button" (click)="removeRow(rowIndex)"
                        [disabled]="rowsArray.length === 1">
                        <mat-icon class="delete-icon" fontSet="material-symbols-outlined">delete</mat-icon>
                    </button>
                </div>
                <ng-container formArrayName="fields">
                    <div class="fields-horizontal">
                        <div *ngFor="let fieldGroup of getFields(rowIndex).controls; let i = index" [formGroupName]="i">

                            <mat-form-field appearance="outline"
                                *ngIf="fieldGroup.get('field_name')?.value?.toLowerCase() === 'country'">
                                <mat-label>{{ fieldGroup.get('field_name')?.value }}</mat-label>
                                <input matInput formControlName="value" [matAutocomplete]="countryAuto"
                                    (focus)="onCountryFocus(rowIndex, i)">
                                <mat-autocomplete #countryAuto="matAutocomplete" [displayWith]="displayCountry">
                                    <mat-option *ngFor="let country of getCountryOptions(rowIndex, i) | async"
                                        [value]="country" (onSelectionChange)="onCountrySelect(country)">
                                        {{ country.name }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error
                                    *ngIf="fieldGroup.get('value')?.hasError('required') && (fieldGroup.get('value')?.touched || isSubmitted)">
                                    {{ fieldGroup.get('field_name')?.value }} is required.
                                </mat-error>
                            </mat-form-field>

                            <mat-form-field appearance="outline"
                                *ngIf="fieldGroup.get('field_name')?.value?.toLowerCase() === 'port'">
                                <mat-label>{{ fieldGroup.get('field_name')?.value }}</mat-label>
                                <input matInput formControlName="value" [matAutocomplete]="portAuto"
                                    (focus)="onPortFocus(rowIndex, i)">
                                <mat-autocomplete #portAuto="matAutocomplete" [displayWith]="displayPort">
                                    <mat-option *ngFor="let port of getPortOptions(rowIndex, i) | async" [value]="port">
                                        {{ port.name }}
                                    </mat-option>
                                </mat-autocomplete>
                                <!-- Error message for the required field -->
                                <mat-error
                                    *ngIf="fieldGroup.get('value')?.hasError('required') && (fieldGroup.get('value')?.touched || isSubmitted)">
                                    {{ fieldGroup.get('field_name')?.value }} is required.
                                </mat-error>
                            </mat-form-field>

                            <!-- Generic input for other fields -->
                            <mat-form-field appearance="outline"
                                *ngIf="fieldGroup.get('field_name')?.value?.toLowerCase() !== 'country' && fieldGroup.get('field_name')?.value?.toLowerCase() !== 'port'">
                                <mat-label>{{ fieldGroup.get('field_name')?.value }}</mat-label>
                                <input matInput
                                    [type]="isNumericField(fieldGroup.get('data_type')?.value) ? 'number' : 'text'"
                                    formControlName="value" />
                                <!-- Error message for range -->
                                <mat-error
                                    *ngIf="fieldGroup.get('value')?.hasError('required') && (fieldGroup.get('value')?.touched || isSubmitted)">
                                    {{ fieldGroup.get('field_name')?.value }} is required.
                                </mat-error>
                            </mat-form-field>
                            <mat-error class="field-error-outside"
                                *ngIf="rowGroup.get('fields')?.errors?.['rangeInvalid'] && fieldGroup.get('field_name')?.value === 'Max Range'">
                                Max Range must be greater than Min Range.
                            </mat-error>
                        </div>
                    </div>
                </ng-container>
            </div>
        </ng-container>
    </div>
</form>